var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarehouse2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    height: "36px",
    width: "36px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4,6.6l-17-6.6c-0.2-0.1-0.5-0.1-0.7,0l-17,6.6C0.3,6.8,0,7.2,0,7.6v4.1c0,0.5,0.5,1,1,1h1V35 c0,0.5,0.5,1,1,1h30c0.5,0,1-0.5,1-1V12.8h1c0.5,0,1-0.5,1-1V7.6C36,7.1,35.7,6.8,35.4,6.6z M17,34.1h-5.7v-5.7h1.8v0.8 c0,0.5,0.5,1,1,1c0.5,0,1-0.5,1-1v-0.8H17V34.1z M24.6,34.1H19v-5.7h1.8v0.8c0,0.5,0.5,1,1,1c0.5,0,1-0.5,1-1v-0.8h1.8V34.1z M27.8,34.1h-1.1v-6.7c0-0.5-0.5-1-1-1H10.3c-0.5,0-1,0.5-1,1v6.7H8.2V18.6c0-0.5,0.5-1,1-1h17.5c0.5,0,1,0.5,1,1V34.1z M29.8,34.1 V18.6c0-1.7-1.4-3-3-3H9.2c-1.7,0-3,1.4-3,3v15.5H3.9V12.8h28L32,34.1H29.8z M34,10.7h-32V8.3l16-6.1l16,6.1V10.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse2);
export default __webpack_public_path__ + "static/media/warehouse-2.deabdf77.svg";
export { ForwardRef as ReactComponent };